<script>
  import _ from 'lodash'
  import { ref } from 'vue/dist/vue.esm-bundler';

  export default {
    template: `<div><slot v-bind="self"/></div>`,
    name: 'AnswerField',
    props: {
      id: Number,
      show: Boolean,
      inputType: null,      // text, number, or etc..
      textInputType: null,  // text, number, or etc..
      initValue: null,
      initTextValue: null,
      initLabelValue: null,
      initFile: null,
      initMaxLength: null,
      initCheckedValues: Array,
      initCheckedTextValues: {},
    },
    data () {
      return {
        value: (this.inputType === 'number') ? this.formatDelimited(this.initValue) : this.initValue,
        textValue: this.initTextValue,
        labelValue: this.initLabelValue,
        file: null,
        maxLength: null,
        checkedValues: this.initCheckedValues,
        checkedTextValues: this.initCheckedTextValues,
        class: null,
        style: null,
        key: null
      }
    },
    mounted () {
      this.changed()
    },
    computed: {
      self() {
        return this;
      },
      isBlankValue () {
        return _.isEmpty(this.value) &&
               _.isEmpty(this.textValue) &&
               _.isEmpty(this.labelValue) &&
               _.isEmpty(this.file)
      },
      wordCount () {
        return _.toString(this.value || '').replace(/\r\n/g, "\n").length
      },
      textValueWordCount () {
        return _.toString(this.textValue || '').replace(/\r\n/g, "\n").length
      },
      labelValueWordCount () {
        return _.toString(this.labelValue || '').replace(/\r\n/g, "\n").length
      },
      checkedTextValuesWordCount () {
        return _.mapValues(this.checkedTextValues, (textValue) => {
          return _.toString(textValue || '').replace(/\r\n/g, "\n").length
        })
      }
    },
    methods: {
      changed () {
        this.$emit('answer-change', this)
      },
      focused (e) {
        if (this.inputType === 'date') {
          const $input = $(e.target)
          const format = $input.hasClass('monthpicker') ? 'yyyy/mm' : 'yyyy/mm/dd'
          $input
            .datepicker('destroy')
            .datepicker({
              language: 'ja-JP',
              format: format,
              autoHide: true,
              inline: this.$root.spMode,
              container: '#calendar-container .modal-body',
              pick: (e) => {
                this.value = $input.datepicker('formatDate', e.date)
                this.$emit('answer-change', this)
                $input.datepicker('hide')
              },
              show: (e) => {
                // for sp inline mode
                $('#calendar-container').addClass('active')
                if (this.$root.spMode) {
                  $input.blur()
                }
              },
              hide: (e) => {
                // for sp inline mode
                $('#calendar-container').removeClass('active')
                $('#calendar-container .modal-body').empty()
                $input.datepicker('destroy')
              }
            })
            .datepicker('show')
        }
      },
      blured (e) {
        if (this.inputType === 'number') {
          this.value = this.formatDelimited(this.value)
        }
      },
      formatDelimited (val) {
        const v = _.toString(val).replace(/,/g, '')
        if ( /^[+|-]?(\d*)(\.\d+)?$/.test(v) ) {
          return v.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return val
        }
      }
    },
    watch: {
      value (newValue, oldValue) {
        if (typeof newValue === 'undefined') {
          return
        }

        if (this.inputType === 'number') {
          // 数値の途中で入力変更があった場合スキップ
          const input = this.$refs['input-el']
          if (input && input.value.length !== input.selectionStart) {
            return
          }

          this.value = this.formatDelimited(newValue)
        }
      },
      textValue (newValue, oldValue) {
        if (typeof newValue === 'undefined') {
          return
        }

        if (this.textInputType === 'number') {
          this.textValue = this.formatDelimited(newValue)
        }
      }
    }
  }
</script>
